<template>
    <div>
        <main class="main-content">
            <div class="page-content">
            <div class="container">
                <div class="page-links"><router-link to="/settings/exchange" class="page-links__item">Exchange Rate</router-link><router-link to="/settings/smtp" class="page-links__item is-active">SMTP</router-link></div>
                <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                <section class="smtp-wrapper" v-if="isLoad">
                <div class="page-title">
                    <h2>Setting & Data | General | SMTP</h2>
                </div>
                <form action="javascript:void(0)" class="smtp-form">
                    <div class="smtp-form__inner">
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Choose Email Account</span>
                        <div :class="['select-wrapper', 'select-wrapper--sm', {'is-active' : selects.account} ]" @click="changeSelects('account')">
                            <div class="select-trigger"><span class="select-trigger__name">{{account}}</span><span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                            <div class="select-body">
                            <div class="select-inner">
                                <div :class="['select-option', {'is-selected' : account === 'Custom'}]" @click="account = 'Custom';isEdit = true"><span class="select-option__name">Custom</span></div>
                                <div :class="['select-option', {'is-selected' : account === 'Custom 1'}]" @click="account = 'Custom 1';isEdit = true"><span class="select-option__name">Custom 1</span></div>
                                <div :class="['select-option', {'is-selected' : account === 'Custom 2'}]" @click="account = 'Custom 2';isEdit = true"><span class="select-option__name">Custom 2</span></div>
                                <div :class="['select-option', {'is-selected' : account === 'Custom 3'}]" @click="account = 'Custom 3';isEdit = true"><span class="select-option__name">Custom 3</span></div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">SMTP Server</span>
                        <div class="form-control-wrap">
                            <input type="text" v-model="inputs.smtpServer" @change="isEdit = true" Placeholder="smpt.yandex.ru" class="form-control"/>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Номер порта</span>
                        <div class="form-control-wrap">
                            <input type="number" v-model="inputs.port" @change="isEdit = true" placeholder="123" class="form-control"/>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Email Address</span>
                        <div class="form-control-wrap">
                            <input type="text" v-model="inputs.email" @change="isEdit = true" Placeholder="test@gmail.com" class="form-control"/>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Login</span>
                        <div class="form-control-wrap">
                            <input type="text" v-model="inputs.login" @change="isEdit = true" Placeholder="Your login" class="form-control"/>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Password</span>
                        <div class="form-control-wrap">
                            <input type="password" v-model="inputs.password" @change="isEdit = true" Placeholder="Your password" class="form-control"/>
                        </div>
                        </div>
                    </div>
                    <div class="smtp-form__col">
                        <div class="form-control-group"><span class="form-control-label">Безопасное подключение</span>
                        <div :class="['select-wrapper', 'select-wrapper--sm', {'is-active' : selects.tsl} ]" @click="changeSelects('tsl')">
                            <div class="select-trigger"><span class="select-trigger__name">{{tsl}}</span><span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                            <div class="select-body">
                            <div class="select-inner">
                                <div :class="['select-option', {'is-selected' : tsl === 'TSL'}]" @click="tsl = 'TSL';isEdit = true"><span class="select-option__name">TSL</span></div>
                                <div :class="['select-option', {'is-selected' : tsl === 'TSL 1'}]" @click="tsl = 'TSL 1';isEdit = true"><span class="select-option__name">TSL 1</span></div>
                                <div :class="['select-option', {'is-selected' : tsl === 'TSL 2'}]" @click="tsl = 'TSL 2';isEdit = true"><span class="select-option__name">TSL 2</span></div>
                                <div :class="['select-option', {'is-selected' : tsl === 'TSL 3'}]" @click="tsl = 'TSL 3';isEdit = true"><span class="select-option__name">TSL 3</span></div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="smtp-form__footer">
                    <div class="smtp-form__footer__side">
                        <button type="button" class="btn btn--green"><span>Send test email</span></button>
                    </div>
                    <div class="smtp-form__footer__side">
                        <button type="button" class="btn btn--silver" @click="$router.back()"><span>Cancel</span></button>
                        <button type="button" class="btn btn--green" @click="editSmtpSettingsHandler"><span>Save</span></button>
                    </div>
                    </div>
                </form>
                </section>
            </div>
            </div>
        </main>
    </div>
</template>

<script>

    import { getSmtpSettings, editSmtpSettings } from '@/utilites/api'

    export default {
        props: ['user'],
        data(){
            return {
                selects: {
                    account: false,
                    tsl: false,
                },
                selectsActive: {
                    // season: '',
                },
                inputs: {
                    smtpServer: '',
                    port: '',
                    login: '',
                    password: '',
                    email: ''
                },
                account: 'Custom',
                tsl: 'TSL',
                isLoad: false,
                isEdit: false
            }
        },
        beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
         beforeCreate(){
            document.title = 'Setting & Data / General / SMTP'
        },
        mounted(){
            document.title = 'Setting & Data / General / SMTP'
            getSmtpSettings(this.user.access_token)
            .then(res => {
                this.inputs = {
                    ...this.inputs,
                    smtpServer: res.smtpServer,
                    port: res.port,
                    login: res.login,
                    password: res.password,
                    // tls
                }
                this.isLoad = true
            })
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        account: false,
                        tsl: false
                    }
                }
            })
        },
        methods: {
            changeSelects(target){
				this.selects = {
                    account: false,
                    tsl: false,
					[target] : !this.selects[target]
				}
			},
            editSmtpSettingsHandler(){
                editSmtpSettings(this.user.access_token, {
                    smtpServer: this.inputs.smtpServer,
                    port: this.inputs.port,
                    login: this.inputs.login,
                    password: this.inputs.password
                })
                .then(res => {
                    this.$emit('confirmed')
                    this.isEdit = false
                })
            }
        }
    }
</script>